/**
 * API client for IP allowlist management endpoints.
 * Routes: /api/mgmt/ip-allowlist
 */

import { apiFetch } from './client';

export interface IpEntry {
  cidr: string;
  scope: string;
  label: string;
  enforce: 'waf' | 'application' | 'both';
  createdAt: string;
  createdBy: string;
}

export interface AddIpEntryData {
  cidr: string;
  scope: string;
  label: string;
  enforce: 'waf' | 'application' | 'both';
}

export async function listIpEntries(token: string, scope?: string): Promise<IpEntry[]> {
  const query = scope ? `?scope=${encodeURIComponent(scope)}` : '';
  const data = await apiFetch<{ entries: IpEntry[] }>(
    `/api/mgmt/ip-allowlist${query}`,
    token,
  );
  return Array.isArray(data) ? data : (data.entries ?? []);
}

export async function addIpEntry(data: AddIpEntryData, token: string): Promise<IpEntry> {
  const resp = await apiFetch<{ entry: IpEntry }>('/api/mgmt/ip-allowlist', token, {
    method: 'POST',
    body: JSON.stringify(data),
  });
  return resp.entry ?? resp as unknown as IpEntry;
}

export async function removeIpEntry(
  scope: string,
  cidr: string,
  token: string,
): Promise<void> {
  return apiFetch<void>(
    `/api/mgmt/ip-allowlist/${encodeURIComponent(scope)}/${encodeURIComponent(cidr)}`,
    token,
    {
      method: 'DELETE',
    },
  );
}

export async function syncWaf(token: string): Promise<{ status: string; message: string }> {
  return apiFetch<{ status: string; message: string }>(
    '/api/mgmt/ip-allowlist/sync-waf',
    token,
    {
      method: 'POST',
    },
  );
}
